


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class MegaphoneIcon extends Vue {
  @Prop({ default: '24' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#525265' }) readonly color?: string;
}
